module.exports = __webpack_public_path__ + "img/datetime.ebfe6ade.svg";